import LazyLoad from './modules/lazyload';
import { addNewTooltipsToButtonGroup } from './modules/tooltips';

var Advisor = function Advisor() {
  var data = [];
  var matchCutoff = 50; // must be at least a 50% match to be returned
  var mobileBreakpoint = 768;
  var cls_selected = 'selected';
  var cls_active = 'is-active';
  var cls_advisorStepHeading = 'advisor-active-step-heading';
  var cls_hidden = 'hidden';
  var cls_option = 'advisor-step-slide';
  var cls_tab = 'filter-tabs-tab';
  var cls_step = 'advisor-step';
  var cls_stepBtn = 'step-btn';
  var cls_stepWrapper = 'advisor-step-wrapper';
  var cls_stepNav = 'advisor-step-nav';
  var cls_stepNavPrev = 'advisor-step-nav-prev';
  var cls_stepNavNext = 'advisor-step-nav-next';
  var attr_id = 'data-paId';
  var $resultWrapperDiv = $('.result-wrapper');
  var currentStep = 1;
  var noMatchDefault = '';
  var numSteps = $('.advisor-step-wrapper').length;
  var nonMatchesHtml = '';
  // var $advisorContainerDiv = $('.product-advisor-container');
  var $stepWrapper = $('.step-wrapper');
  var $recommendationsWrapper = $('.also-consider-content-wrapper');
  var $tabs = $('.filter-tabs');
  var isSlickInitialized = false;

  this.init = function (options) {
    // Set data source
    data = options.data;
    update();
    reanchorPage();
  }

  this.render = function() {
    $(`.${cls_tab} .step-btn`).on('click', function() {
      var stepNum = $(this).parent().index();
      gotoStep(stepNum);
      setAdvisorHeadingToActiveStepLabel();
      initializeSlick();
    });
    // Add event handlers to step options
    $(`.${cls_option}`).on('click', function() {
      var $this = $(this); 
      $this.toggleClass(cls_selected);
      // Deselect every other sibling, except if on step 5
      if (currentStep !== numSteps) {
        $this.siblings().removeClass(cls_selected);
      }
      // Update results
      update();
      reanchorPage();
      // If option is no longer selected, remove focus
      if (!$this.hasClass(cls_selected)) {
        document.activeElement.blur();
      }
    });
    // Advisor step nav (smaller screens)
    $(`.${cls_stepNav}`).on('click', function(event) {
      var $this = $(this);
      if ($this.hasClass(cls_stepNavPrev)) {
        gotoStep(currentStep - 2);
      } else if ($this.hasClass(cls_stepNavNext)) {
        gotoStep(currentStep);
      }
      initializeSlick();
    });
    // Check params for option
    var urlOpt = getParameterByName('option');
    if (urlOpt !== '') {
      var option = $('.' + cls_option + '[' + attr_id + '="' + urlOpt + '"]');
      currentStep = getCurrentStep(option) + 1;
      if (currentStep >= numSteps) {
        currentStep = 1;
      }
      option.addClass(cls_selected);
    }
    // Inits
    // Go to the next step
    gotoStep(currentStep - 1);
    setAdvisorHeadingToActiveStepLabel();
    window.addEventListener('resize', onWindowResize);
    onWindowResize();
    initializeSlick();
  };

  function initializeSlick() {
    $(`.${cls_step}`).each(function() {
      var $this = $(this);
      var slidesToShow = $this.find(`.${cls_option}`).length;
      if (isSlickInitialized) {
        $this.slick('setPosition');
      } else {
        $this.slick({
          arrows: true,
          centerMode: false,
          draggable: false,
          infinite: false,
          mobileFirst: true,
          slidesToShow: 2,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 4,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 3,
              }
            }
          ],
          swipe: false,
          touchMove: false,
        });
      }
      $this.removeClass(cls_hidden);
    });
    isSlickInitialized = true;
  }

  function setAdvisorHeadingToActiveStepLabel() {
    var advisorHeadingDiv = document.querySelector(`.${cls_advisorStepHeading}`);
    var activeStepBtn = document.querySelector(`.${cls_tab}.${cls_active} .${cls_stepBtn}`);
    if (activeStepBtn) {
      var label = activeStepBtn.getAttribute('aria-label');
      advisorHeadingDiv.textContent = label;
    }
  }

  function reanchorPage() {
    $('html, body').animate({
      scrollTop: 0,
    }, 0);
  }

  function onWindowResize() {
    if (window.innerWidth >= mobileBreakpoint) {
      // Assume desktop, show everything
      $tabs.show();
      $stepWrapper.show();
      $recommendationsWrapper.show();
    }
    // Set steps top position
    /* var header = document.querySelector('header');
    if (header) {
      var offsetHeight = header.offsetHeight;
      $advisorContainerDiv.css({'top': `${offsetHeight}px`});
    } */
    updateStepLabels();
  }

  function updateStepLabels() {
    var isMobile = window.innerWidth < mobileBreakpoint;
    var stepBtnList = document.querySelectorAll('.step-btn');
    [].map.call(stepBtnList, function(item) {
      if (isMobile) {
        item.textContent = item.getAttribute('aria-label');
      } else {
        item.textContent = item.getAttribute('data-shortlabel');
      }
    });
  }
  
  function gotoStep(num) {
    currentStep = num + 1;
    setActiveTab();
    setActivePanel();
  }

  function getParameterByName(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  function getCurrentStep(option) {
    return option.closest('.advisor-step-wrapper').index() + 1;
  }

  function setActivePanel() {
    $('.' + cls_stepWrapper).attr('hidden', true);
    $('.' + cls_stepWrapper + ':eq(' + (currentStep - 1) + ')').removeAttr('hidden');
  }

  function setActiveTab() {
    $('.' + cls_tab + '.' + cls_active).removeClass(cls_active);
    $('.' + cls_tab + '.' + cls_active + ' .step-btn').attr('aria-selected', false);
    $('.' + cls_tab + ':eq(' + (currentStep - 1) + ')').addClass(cls_active);
    $('.' + cls_tab + ':eq(' + (currentStep - 1) + ') .step-btn').attr('aria-selected', true);
  }

  function formatOptionHtml(option) {
    return '<p>' + option + '</p>'
  }

  function update() {
    // Reset DOM
    reset();
    var totalScore = 0;
    // What is the total score for each selected option
    $('.' + cls_option + '.' + cls_selected).each(function() {
      totalScore += parseInt($(this).attr('data-paMaxVal'));
    });
    var p, s;
    for (var i = 0; i < data.length; i++) {
      p = data[i];
      p.score = 0;
      p.matchDetails = '';
      p.noMatchDetails = noMatchDefault;
      p.totalScore = totalScore;
      // If nothing is selected, return all
      if ($('.' + cls_option + '.' + cls_selected).length === 0) {
        p.isHidden = false;
        p.percentageMatch = 1;
        p.percentageMatchDisplay = 'N/A';
      } else {
        // Get all selected options
        $('.' + cls_option + '.' + cls_selected).each(function() {
          p.score += p.values[$(this).attr(attr_id)];
          // If we're checking material, then need to be exclusive
          p.isHidden = !materialMatch(p);
          // Wrap option w/ html formatting 
          s = formatOptionHtml($(this).find('.heading-icon').text());
          if (p.values[$(this).attr(attr_id)] === 0) {
            p.noMatchDetails += s;
          } else {
            p.matchDetails += s;
          }
        });
        // Clear out noMatchDetails if no noMatches exist
        if (p.noMatchDetails === noMatchDefault) {
          p.noMatchDetails = '';
        }
        p.percentageMatch = Math.round((p.score / totalScore) * 10000)/100;
        p.percentageMatchDisplay = String(Math.round((p.score / totalScore) * 10000)/100) + '%';

        if (p.score === 0) {
          p.isHidden = true;
        }
      }
    }
    // Multi-dimension sort, by score and isHidden
    data.sort(sort);
    // Below 50% match, cut it off
    var isHighest = -1,
    median = matchCutoff;
    for (i = 0; i < data.length; i++) {
      p = data[i];
      if (!p.isHidden && p.percentageMatch > isHighest) {
        isHighest = p.percentageMatch;
        if (isHighest < median) {
          median = isHighest;
        }
      }
      // console.log('median: ' + median + '        best match %: ' + isHighest + '%');
      if (p.percentageMatch < median) {
        p.isHidden = true;
      }
    }

    // Update DOM
    var logStr = '-------\nMatches\n-------\n';
    var len = 0,
      item;
    for (i = 0; i < data.length; i++) {
      p = data[i];
      item = $('.matched-result[data-product="' + p.id + '"]');
      if (!p.isHidden) {
        logStr += p.name + ': ' + p.percentageMatch + '%\n';
        item.removeClass(cls_hidden);
        // Add match/no-match to tooltips
        item.find('.match .tooltip-inner').empty().append(p.matchDetails);
        item.find('.no-match .tooltip-inner').empty().append(p.noMatchDetails);
        len++;
      } else {
        item.addClass(cls_hidden);
      }
      // Add match/no-match count to tooltip buttons
      var matchCt = item.find('.match .tooltip-inner').children('p').length;
      var noMatchCt = item.find('.no-match .tooltip-inner').children('p').length;
      var matchCtDisplay = '0';
      var noMatchCtDisplay = '0';
      if (matchCt > 0) {
        matchCtDisplay = '+' + matchCt;
        item.find('.card-features .match button').removeAttr('disabled');
      } else {
        item.find('.card-features .match button').attr('disabled', 'disabled');
      }
      if (noMatchCt > 0) {
        noMatchCtDisplay = '+' + noMatchCt;
        item.find('.card-features .no-match button').removeAttr('disabled');
      } else {
        item.find('.card-features .no-match button').attr('disabled', 'disabled');
      }
      item.find('.card-features .match button var').text(matchCtDisplay);
      item.find('.card-features .no-match button var').text(noMatchCtDisplay);
    }
    // If there's no matches
    if (len === 0) {
      logStr += 'No matches.\n'; 
    }
    updateDOM();
    LazyLoad();
    // console.log(logStr);
  }

  function attachTooltipEvents(item) {
    addNewTooltipsToButtonGroup({
      btns: [
        item.querySelector('.match button'),
        item.querySelector('.no-match button'),
      ],
    });
  }

  function updateDOM() {
    // Resort based on what's not hidden, remove the hiddens
    var p, item;
    for (var i = 0; i < data.length; i++) {
      p = data[i];
      item = $('.matched-result[data-product="' + p.id + '"]');
      if (item.hasClass(cls_hidden)) {
        nonMatchesHtml += item[0].outerHTML;
        item.detach();
      } else {
        $resultWrapperDiv.append(item);
        attachTooltipEvents(item[0]);
      }
    }
    // If there are no results in "Also consider..." then hide that div
    // Also vice versa
    if ($('#alsoConsiderContent .matched-result').length === 0) {
      $('#alsoConsiderContent').addClass(cls_hidden);
    } else {
      $('#alsoConsiderContent').removeClass(cls_hidden);
    }   
  }

  function reset() {
    // Readd non-matches to DOM
    $resultWrapperDiv.append(nonMatchesHtml);
    // Reset nonMatchesHtml
    nonMatchesHtml = '';
  }

  function sort(a,b) {
    if (a.percentageMatch < b.percentageMatch)
      return 1;
    if (a.percentageMatch > b.percentageMatch)
      return -1;
    if (a.percentageMatch === b.percentageMatch)
      // Should look at priority here
      if (a.values.Priority !== 0 || b.values.Priority !== 0) {
        return sortPriority(a,b);
      } else {
        return sortAbc(a,b);
      }
  }

  function sortAbc(a,b) {
    if (a.name < b.name)
      return -1;
    if (a.name > b.name)
      return 1;
    return 0;
  }

  function sortPriority(a,b) {
    if (a.values.Priority < b.values.Priority)
      return 1;
    if (a.values.Priority > b.values.Priority)
      return -1;
    return 0;
  }

  function materialMatch(prod) {
    // if there are none selected, do not use as criteria and return all
    if ($('.' + cls_step + ':eq(2) .' + cls_selected).length === 0) {
      return true;
    }
    // Otherwise check
    var match = false;
    $('.' + cls_step +':eq(2) .' + cls_selected).each(function() {
      if (prod.values[$(this).attr(attr_id)] === 1) {
        match = true;
      }
    });
    // See if match, return true/false
    return match;
  }
  return this;
}
// console.log('product-advisor.js, load');
var a = Date.now();
var advisor = new Advisor();
advisor.render();
var request = new XMLHttpRequest();
request.open('GET', 'GetProductAdvisorData', true);
request.onload = () => {
  if (request.status >= 200 && request.status < 400) {
    var data = JSON.parse(request.responseText);
    advisor.init({
      data,
    });
    var b = Date.now();
    // console.log('product-advisor.js, init (' + ((b - a)/1000) + 's)');
  }
};
request.send();